<template lang="pug">
  .wrap
    MapSidebar(
      :openSidebar="activeSidebar"
      @inactivateSidebar="inactivateSidebar"
      @toggleSidebar="toggleSidebar"
      @search="search")

    .main.main-map
      #mapWrap.map-wrap(:class="{ 'sp-map-wrap': spMode && !streetviewMode }")
        .map-search-box(v-if="!streetviewMode")
          a.map-search-open(@click="toggleSidebar") open
          .map-search-form(@click="inactivateSidebar")
            form(action="" onsubmit="return false;")
              input.map-search-input(
                id="map-search-input"
                type="search"
                placeholder="駅名や住所を入力"
                @keydown="keydownCondition"
                @keyup="keyupCondition")
              .map-search-button(@click="searchByPlaceKeyword")
        MapSpCompanyList(
          :companies="this.$store.state.map.index"
          :companyList="this.companyList"
          :companyButtonSp="this.companyButtonSp"
          :spMode="spMode"
          :streetviewMode="streetviewMode"
          @toggle="toggle"
          @openCompanyList="openCompanyList"
          @spMouseoverCompanyList="spMouseoverCompanyList"
        )
        a.company-list-open-button(
          @click="openCompanyList"
          :class="{ 'company-list-close-button': companyButton }"
          v-if="!streetviewMode && !spMode"
        )
          span(v-if="companyButton") 閉じる
          span(v-else) リスト表示
        a.map-company-download(@click="openCsvDownloadModal", v-if="!streetviewMode && !spMode") ダウンロード
        a.all-job-mark(@click="openAllJobMarkModal", v-if="!streetviewMode && !spMode") お気に入り追加
        a.lmt-import(@click="openAddAccountModal", v-if="!streetviewMode && !spMode && user.lead_management") 取引先追加
        #company-list-load
          .loader
        .company-list-box(:class="{ 'company-list-is-active': this.companyList }", v-if="!streetviewMode && !spMode")
          p.count
            | {{ Number(this.$store.state.map.index.length).toLocaleString() }}件
            | ヒット
          ul.company-info-area(v-for="(company, index) in this.$store.state.map.index")
            li(v-on:mouseover="mouseoverCompanyList(company.company_id)" v-on:mouseleave="mouseleaveCompanyList(company.company_id)")
              .company-name
                router-link(:to="{name: 'CompanyDetail', query: { id: company.id, from: 'map' }}" target="_blank") {{ company.company_name }}
                .col.marking(
                  @click="toggle(company)"
                  :class="{ 'on': company.in_job_mark }"
                  :id='`markButtonList${company.company_id}`'
                )
                  span マーキング
              .company-tel
                span(v-if="company.company_tel") {{ company.company_tel }}
                span(v-else) -
              .company-url
                a(
                  v-if="company.company_url"
                  :href="company.company_url"
                  target="_blank"
                  rel="noopener noreferrer"
                ) {{ company.company_url }}
                span(v-else) -
              .company-place
                span(v-if="company.company_place") {{ company.company_place }}
                span(v-else) -
              .company-budget
                span 出稿予算
                ul
                  li 今月：{{ company.budget_current_month }}
                  li 先月：{{ company.budget_last_month }}
                  li 3ヶ月：{{ company.budget_last_quarter }}
                  li 6ヶ月：{{ company.budget_last_harf_year }}
                  li 1年：{{ company.budget_last_year }}
                ul
              .company-published-media
                span 掲載：
                a(
                  v-if="company.published_media_name_all"
                  :href="company.master_url"
                  target="_blank"
                  rel="noopener noreferrer"
                ) {{ company.published_media_name_all }}
                span(v-else) -
        MapPinInfo(:spMode="spMode", v-if="!streetviewMode")
        #mapSearchArea.map-area(@click="inactivateSidebar")
        MapSpInfoWindow(
          :company="company"
          :companyTel="companyTel"
          :companyUrl="companyUrl"
          @close="clearCompany"
          @toggle="toggle")
    AllJobMarkModal(@createinfoWindow="createinfoWindow")
    AddAccountModal(:update="updateIndex")
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'
  import { gmapApi } from 'vue2-google-maps'
  import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer'
  import MapSidebar from '../parts/MapSidebar'
  import MapSpInfoWindow from '../parts/MapSpInfoWindow'
  import MapSpCompanyList from '../parts/MapSpCompanyList'
  import MapPinInfo from '../parts/MapPinInfo'
  import {
    DefaultCenterLat,
    DefaultCenterLng,
    DefaultZoom,
    HumanErrorMessages,
  } from '../../constants'
  import mapGetSet from '../../libs/map-get-set'
  import searchMap from '../../store/modules/searchMap'
  import AllJobMarkModal from '../parts/AllJobMarkModal'
  import AddAccountModal from '../parts/AddAccountModal'

  export default {
    components: { MapSidebar, MapSpInfoWindow, MapSpCompanyList, MapPinInfo, AllJobMarkModal, AddAccountModal },
    async asyncData ({ store, route: { query } }) {
      const loader = document.getElementById('company-list-load')
      const list = document.getElementsByClassName('company-list-is-active')

      if (loader && list.length) {
        loader.classList.add('company-list-load-is-active')
      }

      await store.dispatch('map/fetchIndex', query)

      if (loader && list.length) {
        loader.classList.remove('company-list-load-is-active')
      }
    },
    data () {
      return {
        activeBalloon: false,
        activeSidebar: false,
        activeGeolocationService: false,
        company: null,
        keyDownCode: '',
        map: null,
        markers: [],
        timeoutId: null,
        infoWindowAutoPanMoving: false,
        infoWindowAutoPanMovingTimeoutId: null,
        currentLocationMarker: null,
        mapSearchBoxTimeoutId: null,
        mapSearchBoxLastLeft: 0,
        mapSearchBoxLastTop: 0,
        streetviewMode: false,
        companyList: false,
        companyButton: false,
        companyButtonSp: false,
        cluster: null,
        circle: null,
      }
    },
    computed: {
      ...mapGetters('searchMap', ['apiQuery', 'coordinateDesignated']),
      ...mapGetters('common', ['spMode']),
      ...mapGetters('map', ['index']),
      ...mapGetSet({
        _this: this,
        get: ($vm, $s, k) => $s.state.searchMap.query[k],
        set: ($vm, $s, k, v) => $s.commit(`searchMap/${k}`, v),
        keys: Object.keys(searchMap.state.query),
      }),
      ...mapGetters('user', ['demo']),
      google: gmapApi,
      companyTel () {
        if (!this.company || !this.company.company_tel) {
          return '−'
        }
        return this.company.company_tel.replace(/-/g, '')
      },
      companyUrl () {
        if (!this.company || !this.company.company_url) {
          return '−'
        }
        return this.company.company_url
      },
      ...mapState({
        user: state => state.user.detail,
      }),
    },
    mounted () {
      // mapsize自動調整
      this.adjustMap()
      window.addEventListener('resize', this.adjustMap)

      // google map初期設定
      this.initializeGoogleMap()

      // 初期表示時点の周辺情報取得
      this.search()

      // 現在地表示ボタン表示
      this.renderCurrentLocationButton()

      // 現在地表示(url parameter位置情報 or 現在地取得)
      this.geolocate()
    },
    destroyed () {
      window.removeEventListener('resize', this.adjustMap)
    },
    watch: {
      activeGeolocationService () {
        if (this.activeGeolocationService) {
          this.showCurrentLocationButton()
        }
      },
      index () {
        this.createinfoWindow()
        this.createCircle()
      },
    },
    methods: {
      getCompanyId (company) {
        return company && (company.id || company.company_id)
      },
      adjustMap () {
        const windowHeight = window.innerHeight - 60
        const mapWrap = document.getElementById('mapWrap')
        mapWrap.style.height = `${windowHeight}px`
      },
      clearCompany () {
        this.company = null
      },
      geolocate () {
        // 位置情報取得できない場合は現在地だけ設定
        if (!navigator.geolocation) {
          this.getMapPosition()
          return
        }

        // 現在地取得&設定
        navigator.geolocation.getCurrentPosition(
          (position) => {
            // 座標/zoom指定されていない初期表示時は現在地表示
            if (!this.coordinateDesignated) {
              const latlng = new this.google.maps.LatLng(
                position.coords.latitude,
                position.coords.longitude,
              )
              this.map.panTo(latlng)
              this.setCurrentLocationMarker(latlng)
            }
            setTimeout(() => {
              this.getMapPosition()
              this.activeGeolocationService = true
              this.search()
            }, 3000)
          },
          () => {
            this.$store.dispatch('common/pushToastError', {
              error: new Error(HumanErrorMessages.CANNOT_GET_CURRENT_POSITION),
            })
          },
        )
      },
      getMapPosition () {
        const bounds = this.map.getBounds()
        const center = this.map.getCenter()
        if (bounds && center) {
          this.mapNeLat = bounds.getNorthEast().lat()
          this.mapSwLat = bounds.getSouthWest().lat()
          this.mapNeLon = bounds.getNorthEast().lng()
          this.mapSwLon = bounds.getSouthWest().lng()
          this.centerLat = center.lat()
          this.centerLng = center.lng()
          this.zoom = this.map.getZoom()
        }
      },
      inactivateSidebar () {
        this.activeSidebar = false
        this.adjustMap()
      },
      initializeGoogleMap () {
        const query = this.$route.query
        const initialLat = Number(query.centerLat) || DefaultCenterLat
        const initialLng = Number(query.centerLng) || DefaultCenterLng
        const initialZoom = Number(query.zoom) || DefaultZoom
        const mapdiv = document.getElementById('mapSearchArea')
        const myOptions = {
          zoom: initialZoom,
          center: new this.google.maps.LatLng(initialLat, initialLng),
          mapTypeId: this.google.maps.MapTypeId.ROADMAP,
          mapTypeControl: false,
        }
        this.map = new this.google.maps.Map(mapdiv, myOptions)
        this.map.addListener('drag', () => { this.researchCurrentPosition() })
        this.map.addListener('zoom_changed', () => { this.researchCurrentPosition() })

        // cluster初期化処理
        const algorithm = new SuperClusterAlgorithm({})
        const renderer = {
          render: ({ count, position }, stats) => {
            const color = count > Math.max(10, stats.clusters.markers.mean) ? '#009933' : '#66ccff'
            const svg = window.btoa(`
              <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
                <circle cx="120" cy="120" opacity=".7" r="70" />
                <circle cx="120" cy="120" opacity=".4" r="90" />
                <circle cx="120" cy="120" opacity=".3" r="110" />
              </svg>`)
            return new this.google.maps.Marker({
                position,
                icon: {
                    url: `data:image/svg+xml;base64,${svg}`,
                    scaledSize: new this.google.maps.Size(45, 45),
                },
                label: {
                    text: String(count),
                    color: 'rgba(255,255,255,1.0)',
                    fontSize: '12px',
                },
                title: `Cluster of ${count} markers`,
                zIndex: Number(this.google.maps.Marker.MAX_ZINDEX) + count,
            })
          },
        }

        const map = this.map
        const markers = []
        this.cluster = new MarkerClusterer({ map, markers, algorithm, renderer })

        // Streetview表示時は検索部を非表示にする
        const sview = this.map.getStreetView()
        this.google.maps.event.addListener(sview, 'visible_changed', () => {
          this.streetviewMode = sview.getVisible()
        })
      },
      keydownCondition (e) {
        this.keyDownCode = e.which
      },
      keyupCondition (e) {
        // Enter押下時に検索する。keyDownCode持ってるのは日本語変換のEnterを無視するため
        if (e.which === 13 && e.which === this.keyDownCode) {
          this.searchByPlaceKeyword()
        }
      },
      mapPinClick () {
        this.activeBalloon = true
      },
      renderCurrentLocationButton () {
        const controlDiv = document.createElement('div')
        controlDiv.id = 'current_location_button'
        controlDiv.style.display = 'none'

        const firstChild = document.createElement('button')
        firstChild.style.backgroundColor = '#fff'
        firstChild.style.border = 'none'
        firstChild.style.outline = 'none'
        firstChild.style.width = '40px'
        firstChild.style.height = '40px'
        firstChild.style.borderRadius = '2px'
        firstChild.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)'
        firstChild.style.cursor = 'pointer'
        firstChild.style.marginRight = '10px'
        firstChild.style.padding = '0px'
        firstChild.title = 'Your Location'
        controlDiv.appendChild(firstChild)

        const secondChild = document.createElement('div')
        secondChild.style.margin = '5px'
        secondChild.style.marginLeft = '10px'
        secondChild.style.width = '18px'
        secondChild.style.height = '18px'
        secondChild.style.backgroundImage = 'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-1x.png)'
        secondChild.style.backgroundSize = '180px 18px'
        secondChild.style.backgroundPosition = '0px 0px'
        secondChild.style.backgroundRepeat = 'no-repeat'
        secondChild.id = 'you_location_img'
        firstChild.appendChild(secondChild)

        this.google.maps.event.addListener(this.map, 'dragend', () => {
          const img = document.getElementById('you_location_img')
          if (img) {
            img.style.backgroundPosition = '0px 0px'
          }
        })

        firstChild.addEventListener('click', () => {
          let imgX = '0'
          const animationInterval = setInterval(() => {
            if (imgX === '-18') {
              imgX = '0'
            } else {
              imgX = '-18'
            }
            const img = document.getElementById('you_location_img')
            if (img) {
              img.style.backgroundPosition = `${imgX}px 0px`
            }
          }, 500)
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                const latlng = new this.google.maps.LatLng(
                  position.coords.latitude,
                  position.coords.longitude,
                )
                this.map.panTo(latlng)
                this.setCurrentLocationMarker(latlng)
                this.getMapPosition()
                this.activeGeolocationService = true
                this.search()

                clearInterval(animationInterval)
                const img = document.getElementById('you_location_img')
                if (img) {
                  img.style.backgroundPosition = '-144px 0px'
                }
              },
              () => {
                this.$store.dispatch('common/pushToastError', {
                  error: new Error(HumanErrorMessages.CANNOT_GET_CURRENT_POSITION),
                })
              },
            )
          } else {
            clearInterval(animationInterval)
            const img = document.getElementById('you_location_img')
            if (img) {
              img.style.backgroundPosition = '0px 0px'
            }
          }
        })
        controlDiv.index = 1
        this.map.controls[this.google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv)
      },
      researchCurrentPosition () {
        if (!this.infoWindowAutoPanMoving) {
          clearTimeout(this.timeoutId)
          this.timeoutId = setTimeout(() => {
            this.getMapPosition()
            this.search()
          }, 1000)
        }
      },
      search () {
        const { name } = this.$route
        this.$store.commit('common/lockGlobal')
        try {
          this.$router.push({
            name,
            query: {
              ...this.apiQuery,
              _t: Date.now(),
            },
          })
        } finally {
          this.$emit('toggleSidebar')
          this.$store.commit('common/unlockGlobal')
        }
        this.inactivateSidebar()
      },
      searchByPlaceKeyword () {
        this.$store.commit('common/lockGlobal')
        const geocoder = new this.google.maps.Geocoder()
        const placeKeyword = document.getElementById('map-search-input')
        geocoder.geocode({ address: placeKeyword.value },
          (results, status) => {
            this.$store.commit('common/unlockGlobal')
            if (status === this.google.maps.GeocoderStatus.OK) {
              this.map.setCenter(results[0].geometry.location)
              this.researchCurrentPosition()
            } else {
              this.$store.dispatch('common/pushToastError', {
                error: new Error(HumanErrorMessages.PLACE_NOT_FOUND),
              })
            }
          })
      },
      setCurrentLocationMarker (currentLatlng) {
        if (this.currentLocationMarker) {
          this.currentLocationMarker.setMap(null)
        }

        const iconUrl = `/static/images/sprite/map_center${this.spMode ? '@2x' : ''}.png`
        const iconHeight = this.spMode ? 25 : 27
        const iconWidth = this.spMode ? 25 : 27
        this.currentLocationMarker = new this.google.maps.Marker({
          position: currentLatlng,
          icon: {
            url: iconUrl,
            scaledSize: new this.google.maps.Size(iconHeight, iconWidth),
          },
          map: this.map,
          animation: this.google.maps.Animation.DROP,
          title: 'Your position',
        })
        this.currentLocationMarker.setMap(this.map)
      },
      showCurrentLocationButton () {
        const button = document.getElementById('current_location_button')
        // DOM構築と現在地取得(非同期)のタイミングによって見つからない場合がある。その場合リトライ
        if (!button) {
          setTimeout(this.showCurrentLocationButton, 300)
        } else {
          button.style.display = 'block'
        }
      },
      toggleSidebar (e) {
        e.stopPropagation()
        this.activeSidebar = !this.activeSidebar
      },
      ...mapActions('jobMark', ['add', 'remove']),
      async toggle (company) {
        if (company.in_job_mark) {
          if (company.job_mark_user !== this.user.name) {
            return
          }
        }

        this.$store.commit('common/lockGlobal')
        try {
          company.in_job_mark
            ? await this.remove({ id: company.company_id })
            : await this.add({ id: company.company_id })

          this.$store.commit('map/changeJobMark', { value: !company.in_job_mark, companyId: company.company_id, user: this.user })
          const markButtonPin = document.getElementById(`markButton${company.company_id}`)
          const markButtonList = document.getElementById(`markButtonList${company.company_id}`)

          if (company.in_job_mark) {
            markButtonList.classList.add('on')
            markButtonPin.classList.add('on')
          } else {
            markButtonList.classList.remove('on')
            markButtonPin.classList.remove('on')
          }

          this.$store.commit('common/unlockGlobal')
        } catch (e) {
          this.$store.commit('common/unlockGlobal')
        }
      },
      openCompanyList () {
        this.companyList = !this.companyList
        this.companyButton = !this.companyButton
        this.companyButtonSp = !this.companyButtonSp
      },
      mouseoverCompanyList (companyId) {
        const result = this.markers.find(u => u.get('id') === String(companyId))
        result.set('animation', this.google.maps.Animation.BOUNCE)
      },
      async spMouseoverCompanyList (companyId) {
        const result = this.markers.find(u => u.get('id') === String(companyId))
        result.set('animation', this.google.maps.Animation.BOUNCE)
        this.companyList = !this.companyList
        this.companyButtonSp = !this.companyButtonSp

        // 3秒間だけ跳ねさせる
        const sleep = ms => new Promise(res => setTimeout(res, ms))
        await sleep(3000)
        result.set('animation', null)
      },
      mouseleaveCompanyList (companyId) {
        const result = this.markers.find(u => u.get('id') === String(companyId))
        result.set('animation', null)
      },
      openCsvDownloadModal () {
        const companyIds = []
        this.$store.state.map.index.forEach((company) => {
          const companyId = this.getCompanyId(company)
          if (companyId) companyIds.push(companyId)
        })

        this.$store.commit('map/copyCompanyIds', companyIds)

        if (this.demo) {
          this.$store.dispatch('common/pushToastError', {
            error: new Error(HumanErrorMessages.FORBIDDEN),
          })
          return
        }

        this.$store.commit('common/setCsvTarget', 'company')
        this.$store.commit('common/setMapCompanyModalMode')
        this.$store.commit('common/showModal')
      },
      openAllJobMarkModal () {
        const companyIds = []
        this.$store.state.map.index.forEach((company) => {
          const companyId = this.getCompanyId(company)
          if (companyId) companyIds.push(companyId)
        })

        this.$store.commit('map/copyCompanyIds', companyIds)
        this.$store.commit('map/openModal')
      },
      async openAddAccountModal () {
        const companyIds = []
        this.$store.state.map.index.forEach((company) => {
          const companyId = this.getCompanyId(company)
          if (companyId) companyIds.push(companyId)
        })

        this.$store.dispatch('account/showModal', companyIds)
      },
      updateIndex (ids) {
        this.$store.commit('jobMark/updateIndexForAccount', ids)
        this.$store.commit('jobMark/uncheckAll')
      },
      createinfoWindow () {
        const data = this.$store.state.map.index

        this.markers.forEach((marker) => {
          marker.setMap(null)
        })
        this.markers = []

        if (data.length > 0) {
          const infoWindowList = []
          data.forEach((d) => {
            if (!d.company_place_geo) {
              return
            }

            const companyTelElement = d.company_tel ?
              `
                <a href="tel:${d.company_tel}">
                  ${d.company_tel}
                </a>
              ` :
              '<span>−</span>'
            const companyUrlElement = d.company_url ?
              `
                <a href="${d.company_url}", target="_blank" rel="noopener noreferrer">
                  ${d.company_url}
                </a>
              ` :
              '<span>−</span>'
            const publishedMediaNameAll = d.published_media_name_all ?
              `
                <a href="${d.master_url}" target="_blank" rel="noopener noreferrer">
                  ${d.published_media_name_all}
                </a>
              ` :
              '<span>−</span>'
            const JobMark = d.in_job_mark ?
              `
                <div class="col marking on" id="markButton${d.id}"><span>マーキング</span></div>
              ` :
              `
                <div class="col marking" id="markButton${d.id}"><span>マーキング</span></div>
              `

            const infoWindow = new this.google.maps.InfoWindow({
              content: `
                <div class="map-balloon active">
                  <div class="map-balloon-box">
                    <div class="company_name">
                      <a href="/company?id=${d.id}&from=map" target="_blank" rel="noopener noreferrer">${d.company_name}</a>
                      ${JobMark}
                    </div>
                    <div class="company_tel">
                      ${companyTelElement}
                    </div>
                    <div class="company_url">
                      ${companyUrlElement}
                    </div>
                    <div class="company_place">
                      ${d.company_place ? d.company_place : '−'}
                    </div>
                    <div class="budget">
                      <span>出稿予算</span>
                      <ul>
                        <li>今月：${d.budget_current_month}</li>
                        <li>先月：${d.budget_last_month}</li>
                        <li>3ヶ月：${d.budget_last_quarter}</li>
                        <li>6ヶ月：${d.budget_last_harf_year}</li>
                        <li>1年：${d.budget_last_year}</li>
                      </ul>
                    </div>
                    <div class="published_media">
                      掲載：
                      ${publishedMediaNameAll}
                    </div>
                  </div>
                </div>
              `,
            })
            infoWindowList.push(infoWindow)

            const updateJobMark = () => {
              this.toggle(d)
            }

            this.google.maps.event.addListener(infoWindow, 'domready', () => {
              const markButton = document.getElementById(`markButton${d.id}`)
              markButton.addEventListener('click', updateJobMark)
            })

            const iconUrl = `/static/images/sprite/map_pin_0${d.pin_group}${this.spMode ? '@2x' : ''}.png`
            const iconHeight = this.spMode ? 17 : 27
            const iconWidth = this.spMode ? 27 : 43
            const marker = new this.google.maps.Marker({
              position: {
                lat: d.company_place_geo.lat,
                lng: d.company_place_geo.lon,
              },
              icon: {
                url: iconUrl,
                scaledSize: new this.google.maps.Size(iconHeight, iconWidth),
              },
              map: this.map,
            })
            marker.set('id', d.id)
            marker.addListener('click', () => {
              infoWindowList.forEach((iw) => {
                iw.close()
              })

              if (!this.spMode) {
                // infoWindowクリック時の移動では再検索かけない
                this.infoWindowAutoPanMoving = true
                infoWindow.open(this.map, marker)

                // infoWindowクリック時の移動では再検索かけない制限は1秒後にクリア
                clearTimeout(this.infoWindowAutoPanMovingTimeoutId)
                this.infoWindowAutoPanMovingTimeoutId = setTimeout(() => {
                  this.infoWindowAutoPanMoving = false
                }, 1000)
              } else {
                // 'parts/MapSpInfoWindow.vue' のClickOutsideを動作させない為にe.stopPropagationしたいが
                // e.stopPropagation出来なかったので、Click後時間差で設定する
                setTimeout(() => { this.company = d }, 100)
              }
            })
            this.markers.push(marker)
          })
        }
        this.cluster.clearMarkers()
        this.cluster.addMarkers(this.markers)
      },
      createCircle () {
        if (this.circle !== null) {
          this.circle.setRadius(0)
        }

        if (this.apiQuery.distance !== '') {
          this.circle = new this.google.maps.Circle({
            center: new this.google.maps.LatLng(this.centerLat, this.centerLng),
            fillColor: '#66ccff',
            fillOpacity: 0.1,
            radius: Number(this.apiQuery.distance),
            map: this.map,
            strokeColor: '#66ccff',
            strokeOpacity: 1,
            strokeWeight: 2,
          })
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/search/SearchMap.vue